import { BoosterType } from '../../game/boosters/types';

export enum InventoryItem {
  Coin = 'Coin',
  Lives = 'Lives',
  UnlimitedLivesMinutes = 'UnlimitedLivesMinutes',
  BoosterHammer = 'BoosterHammer',
  BoosterMove = 'BoosterMove',
  BoosterRedraw = 'BoosterRedraw',
  BoosterUndo = 'BoosterUndo',
  FreeSpin = 'FreeSpin',
}

export const boosterToInventoryMap: Record<BoosterType, InventoryItem> = {
  [BoosterType.Redraw]: InventoryItem.BoosterRedraw,
  [BoosterType.Hammer]: InventoryItem.BoosterHammer,
  [BoosterType.Move]: InventoryItem.BoosterMove,
  [BoosterType.Undo]: InventoryItem.BoosterUndo,
};

export enum TransactionReason {
  LevelWinReward = 'LevelWinReward',
  LevelWinDoubleReward = 'LevelWinDoubleReward',
  BuyRevive = 'BuyRevive',
  UseLife = 'UseLife',
  BuyLives = 'BuyLives',
  LifeRequestReward = 'LifeRequestReward',
  UseBooster = 'UseBooster',
  BuyBooster = 'BuyBooster',
  ShopPurchase = 'ShopPurchase',
  LevelFailPopupPurchase = 'LevelFailPopupPurchase',
  DailyReward = 'DailyReward',
  CoinBlocker = 'CoinBlocker',
  WinStreakReward = 'WinStreakReward',
  RaceEventReward = 'RaceEventReward',
  DioramaCompleteReward = 'DioramaCompleteReward',
  ShopFreeGift = 'ShopFreeGift',
  SeasonPassReward = 'SeasonPassReward',
  LuckyWheelFreeSpinReward = 'LuckyWheelFreeSpinReward',
  LuckyWheelAdSpinReward = 'LuckyWheelAdSpinReward',
  CollectionEventReward = 'CollectionEventReward',
  DuelEntry = 'DuelEntry',
  DuelReward = 'DuelReward',
  UseRewardedLuckyWheelFreeSpin = 'UseRewardedLuckyWheelFreeSpin',
}

export type ResourceMap = { [key in InventoryItem]?: number };
